<template>
  <div class="mt-5 mb-3">
    <fieldset :disabled="submitalLocked" style="min-height: calc(100vh - 330px);">
      <Design
        ref="currentStepComponent"
        v-if="currentStep === 'design'"
        :update-configurable="updateConfigurable"
        @update-submital="updateSubmital"
      />
      <Conditions v-if="currentStep === 'conditions'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
      <Dimensions v-if="currentStep === 'dimensions'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
      <Products v-if="currentStep === 'products'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
      <Components v-if="currentStep === 'components'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
      <Electrical v-if="currentStep === 'electrical'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
      <Limitations v-if="currentStep === 'limitations'" ref="currentStepComponent" :update-configurable="updateConfigurable"/>
    </fieldset>

    <ConfiguratorStepButtons
      :is-first-step="isFirstStep"
      :is-last-step="isLastStep"
      @saveStepData="handleStepSave"
    />

    <!-- Alert -->
    <ToastAlert :show="alertShow" :variant="alertVariant" @close="alertShow = false">
      {{ alertMessage }}
    </ToastAlert>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ToastAlert from '../../../../components/shared/ToastAlert'

import ConfiguratorStepButtons from '../ConfiguratorStepButtons.vue'
import Design from './Design'
import Conditions from './Conditions'
import Dimensions from './Dimensions'
import Products from './Products.vue'
import Components from './Components'
import Electrical from './Electrical'
import Limitations from './Limitations'

export default {
  name: 'Configurator',
  components: {
    Design,
    Conditions,
    Dimensions,
    Products,
    Components,
    Electrical,
    Limitations,
    ConfiguratorStepButtons,
    ToastAlert
  },
  data () {
    return {
      submitalId: Number(this.$route.params.id),
      updatingSubmital: false,
      updatingConfigurable: false,
      alertShow: false,
      alertVariant: null,
      alertMessage: ''
    }
  },
  computed: {
    ...mapState({
      currentStep: state => state.configurator.currentStep
    }),
    ...mapGetters(['configurableId', 'isFirstStep', 'isLastStep', 'submitalLocked']),
    processing () {
      return this.updatingSubmital || this.updatingConfigurable
    }
  },
  methods: {
    updateConfigurable (formData) {
      if (this.submitalLocked) {
        return true
      }

      if (this.updatingConfigurable || Object.keys(formData).length === 0) return false
      this.updatingConfigurable = true
      return this.$http.patch(`/api/production/submitals/${this.$route.params.id}/anden_bordes/${this.configurableId}`, {
        anden_borde: { ...formData }
      })
      .then((res) => {
        // console.log('Configurable updated', res.data)
        this.$store.commit('setConfigurable', res.data)
        this.$store.commit('setSubmital', res.data.submital)
        return true // this is needed in handleStepSave to continue
      })
      .catch(() => false)
      .finally(() => this.updatingConfigurable = false)
    },
    updateSubmital (formData) {
      if (this.submitalLocked) {
        return true
      }

      if (this.updatingSubmital || !formData || Object.keys(formData).length === 0) { return }
      this.updatingSubmital = true
      this.$http.patch(`/api/production/submitals/${this.$route.params.id}`, {
        submital: { ...formData }
      })
      .then((res) => {
        // console.log('Submital updated', res.data)
        this.$store.commit('setSubmital', res.data)
      })
      .finally(() => this.updatingSubmital = false)
    },
    async handleStepSave (action) {
      const stepComponent = this.$refs.currentStepComponent

      if (!stepComponent) {
        console.warn('No step component defined')
        return
      }

      if (!stepComponent?.update) {
        console.warn('No update method defined in current step component')
        return
      }

      const successResponse = await stepComponent.update()

      if (!successResponse) {
        if (this.submitalLocked) {
          this.displayAlert({ message: 'El submital está bloqueado y no puede editarse', variant: 'danger', time: 4000 })
          return
        }

        this.displayAlert({ message: 'Hubo un error al guardar cambios, intente de nuevo', variant: 'danger', time: 4000 })
        return
      }

      if (action === 'approve') {
        this.$router.push({ name: 'SubmitalShow', params: { id: this.submitalId }})
        return
      }

      // Go to step
      this.$store.dispatch(action)
    },
    displayAlert ({ message, variant, time=2000 }) {
      this.alertVariant = variant
      this.alertMessage = message
      this.alertShow = true
      setTimeout(() => this.alertShow = false, time)
    }
  }
}
</script>
